<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :show-title="true"
    :width="'80%'"
    :height="700"
    :title="getTitle.primary"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-work-order-release-info',
    }"
    ref="gc-popup"
  >
    <DxToolbarItem
      v-if="getTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${getTitle.secondary}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form">
      <gc-form
        :key="1"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="getFormModel"
        :form-mode="'review'"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 85"
      />

      <div class="data-grid">
        <dx-data-grid
          v-if="getVisible"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getColumns"
          :data-source="getDataSourceConfig"
          :row-alternation-enabled="true"
          :height="getGridHeight"
          :width="'100%'"
          :ref="'so-list-grid'"
        >
          <DxSearchPanel :visible="false" />

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";
import { WorkOrderService } from "../_services/api/production/work-order.service";

export default {
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
  },
  data() {
    return {
      model: {},
    };
  },
  created() {},
  methods: {
    onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },
  },
  computed: {
    getGridHeight() {
      return 570;
    },
    getDataSourceConfig() {
      var date = new Date(
        this.popupConfig.dataModel.ReleaseDate
      ).toFilterDateString();

      return WorkOrderService.dataSourceConfig("api/ReleaseDetailList", {
        filter: `WorkOrderCode eq ${parseInt(
          this.popupConfig.dataModel.WorkOrderCode
        )} and ProductCode eq '${
          this.popupConfig.dataModel.ProductCode
        }' and ReleaseDate eq ${date}`,
        select: [
          "WorkOrderCode",
          "ProductCode",
          "ReleaseCode",
          "ProductionUMQty",
          "StockUMQty",
          "ProductionUM",
          "StockUM",
          "ReleaseDate",
        ],
      });
    },
    getColumns() {
      return [
        {
          caption: "Release #",
          dataField: "ReleaseCode",
          alignment: "left",
          sortOrder: "desc",
          sortIndex: 0,
        },
        {
          screenField: "SalesUM",
          caption: "Production UM",
          dataField: "ProductionUM",
          minWidth: ColumnWidth.ProductionUnitOfMeasure.minWidth,
          width: ColumnWidth.ProductionUnitOfMeasure.width,
          allowSorting: true,
        },
        {
          caption: "Production UM Qty",
          dataField: "ProductionUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
        },
        {
          screenField: "StockUM",
          dataField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          caption: "Stock UM Qty",
          dataField: "StockUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
        },
      ];
    },
    getFormModel() {
      return this.popupConfig.dataModel;
    },
    getHeaderFormItems() {
      return [
        {
          label: {
            text: "Release Date",
          },
          dataField: "ReleaseDate",
          editorType: "dxDateBox",
          editorOptions: {
            displayFormat: "dd MMM yyyy",
            width: 150,
          },
        },
      ];
    },
    getTitle() {
      return {
        primary: this.popupConfig.dataModel.ProductCode,
        secondary: this.popupConfig.dataModel.ProductDescription,
      };
    },
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "Cancel",
            stylingMode: "outlined",
            type: "danger",
            onClick: this.onPopupHide,
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.gc-popup-work-order-release-info {
  .data-grid {
    padding-top: 10px;
  }
}
</style>
